import styled from "styled-components";

export const ModalContent = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
`;